import Show from '../show'

function PoDashboard() {
  return (
    <Show
      title="Purchasing Dashboard"
      dashboardKey="po_dashboards"
      showYear={false}
    />
  )
}

export default PoDashboard
